
function createIntersectionObserver(callback, options = {}) {
  const defaultOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  }

  const observerOptions = { ...defaultOptions, ...options };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          callback(entry.target, true);
        } else {
          callback(entry.target, false);
        }
      });
    }, observerOptions);

    return {
      observe: (element) => observer.observe(element),
      unobserve: (element) => {
        if (element) {
          observer.unobserve(element)
        }
      },
      disconnect: () => observer.disconnect(),
    };
  } else {

  }


}

export default createIntersectionObserver;